<template>
  <div class="service-container">
    <div class="full box">
      <service-item
        v-for="serv in services"
        :key="services.indexOf(serv)"
        :link="serv.link"
        :image="serv.image"
      >{{serv.title}}</service-item>
    </div>
  </div>
</template>

<script>
import ServiceItem from '@/components/ItemService.vue';

import Corporativo from '@/assets/images/coporativo.jpg';
import Administrativo from '@/assets/images/administrativo.jpg';
import Trabajo from '@/assets/images/work.jpg';
import Procesal from '@/assets/images/procesal.jpg';
import Comercial from '@/assets/images/comercial.jpg';

export default {
  name: 'ServiceContainer',
  components: {
    ServiceItem,
  },
  data() {
    return {
      services: [
        {
          title: 'Derecho Trabajo',
          image: Trabajo,
          link: 'trabajo',
        },
        {
          title: 'Derecho Administrativo',
          image: Administrativo,
          link: 'administrativo',
        },
        {
          title: 'Derecho Comercial',
          image: Comercial,
          link: 'comercial',
        },
        {
          title: 'Derecho Procesal',
          image: Procesal,
          link: 'procesal',
        },
        {
          title: 'Penal Corporativo',
          image: Corporativo,
          link: 'corporativo',
        },
        {
          title: 'Otros',
          image: Comercial,
          link: 'otros',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
div.service-container {
  .gallery {
    -webkit-column-gap: 0;
    column-gap: 0;
  }

  @media (min-width: 480px) {
    .gallery {
      -webkit-column-count: 2;
      column-count: 2;
    }
  }

  @media (min-width: 1260px) {
    .gallery {
      -webkit-column-count: 3;
      column-count: 3;
    }
  }
}
</style>
